{
  "wallboard": {
    "instances_count": "нет экземпляров | {count} экземпляр | {count} экземпляров",
    "label": "Доска"
  }
}
